// "Comment ça marche" as a bottom sheet — a permanent, reachable explainer for
// anyone past onboarding who wants a reminder of what Cercle is, or who finds
// the security mechanisms (recovery phrase, verification fingerprint) unusual
// and wants them spelled out in plain terms. Same overlay pattern as
// addFriendSheet/installSheet: a transient element appended to <body>,
// independent of the router, so it can be opened from anywhere (Settings, the
// dashboard intro card) without leaving the current screen.

import { h } from './dom';
import { bullet } from './components';

function sectionTitle(text: string): HTMLElement {
  return h('h2', { class: 'section-title', text });
}

export function openHowItWorksSheet(): void {
  const scrim = h('div', { class: 'sheet-scrim' });
  const handle = h('div', { class: 'sheet-handle' });
  const title = h('h2', { class: 'sheet-title', text: 'Comment ça marche' });
  const overlay = h('div', { class: 'sheet-overlay' });

  let closing = false;
  const close = (): void => {
    if (closing) return;
    closing = true;
    document.removeEventListener('keydown', onKey);
    overlay.classList.remove('is-open');
    setTimeout(() => overlay.remove(), 320);
  };
  const onKey = (e: KeyboardEvent): void => {
    if (e.key === 'Escape') close();
  };
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', onKey);

  const sheet = h(
    'div',
    { class: 'sheet', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Comment ça marche' },
    handle,
    title,
    h('p', {
      class: 'lead',
      text: 'Cercle est un carnet d’adresses vivant : vous tenez votre fiche à jour une fois, vos proches la reçoivent aussitôt.',
    }),
    sectionTitle('Trois gestes, c’est tout'),
    h(
      'ul',
      { class: 'onb-bullets' },
      bullet('edit', 'Vous remplissez votre fiche', 'Nom, téléphone, adresses… Vous êtes la seule personne à pouvoir l’écrire.'),
      bullet('qr', 'Chacun ajoute l’autre', 'Vous ajoutez son ID Cercle, il ajoute le vôtre. Tant qu’il manque un des deux, aucune coordonnée ne circule.'),
      bullet('refresh', 'Tout reste à jour', 'À chaque modification, la nouvelle version part toute seule chez vos proches.'),
    ),
    sectionTitle('Votre sécurité, en clair'),
    h(
      'ul',
      { class: 'onb-bullets' },
      bullet(
        'key',
        'Votre phrase de récupération',
        'Vos douze mots ne quittent jamais cet appareil. C’est votre seul moyen de retrouver votre Cercle sur un autre téléphone : personne ne peut vous les redonner.',
      ),
      bullet(
        'shield',
        'L’empreinte de vérification',
        'Des chiffres que vous et votre proche devez voir à l’identique. S’ils correspondent, vous êtes bien connectés l’un à l’autre.',
      ),
    ),
  );
  overlay.append(scrim, sheet);
  document.body.append(overlay);
  requestAnimationFrame(() => overlay.classList.add('is-open'));
}
